require('./cardStateFilter.scss');

const PropTypes = require('prop-types');

const React = require('react');
const { FormattedText } = require('core/i18n').i18n;
const PureRenderMixin = require('react-addons-pure-render-mixin');
const { RadioButton } = require('commonsComponents/radioButton');
const { RadioButtonGroup } = require('commonsComponents/radioButtonGroup');

//@constants
const {
    CARD_STATE_FILTER_ALL,
    CARD_STATE_FILTER_DEFERRED,
    CARD_STATE_FILTER_NOT_DEFERRED
} = require('constants/index');

class CardStateFilter extends React.Component {
    constructor(props) {
        super(props);
        const { immFilter } = this.props;

        this.state = {
            selected: immFilter.get('selected')
        };

        this.handleFilterChange = this.handleFilterChange.bind(this);
        this.buildRadioButtons = this.buildRadioButtons.bind(this);
        this.shouldComponentUpdate = PureRenderMixin.shouldComponentUpdate.bind(this);
    }

    buildRadioButtons() {
        const options = [CARD_STATE_FILTER_ALL, CARD_STATE_FILTER_DEFERRED, CARD_STATE_FILTER_NOT_DEFERRED];
        const labels = ['filterCardState-all', 'filterCardState-deferred', 'filterCardState-notDeferred'];

        return options.map((option, index) => {
            const label = (
                <div className="state-filter__radio-label">
                    <FormattedText className="state-filter__radio-label-primary" value={labels[index]} /> 
                </div>
            );

            return (
                <RadioButton
                    className="state-filter__radio-option"
                    key={index}
                    label={label}
                    value={option}
                />
            );
        });
    }

    handleFilterChange(value) {
        const selected = value === CARD_STATE_FILTER_ALL ? '' : value;

        this.setState({
            selected
        });

        this.props.onChangeSelected(selected);
    }

    render() {
        const radioButtonsSection = this.buildRadioButtons();
        const selectedValue = !!this.state.selected ? this.state.selected : CARD_STATE_FILTER_ALL;

        return (
            <div className={this.props.last ? 'state-filter__last' : 'state-filter'}>
                <h3 className="state-filter__title">
                    <FormattedText value="filterCardState-title" />
                </h3>
                <RadioButtonGroup
                    name="state-filter"
                    idPrefix="state-filter-radio"
                    selectedValue={selectedValue}
                    onChange={this.handleFilterChange}
                    className="state-filter__options"
                >
                    {radioButtonsSection}
                </RadioButtonGroup>
            </div>
        );
    }
}

CardStateFilter.propTypes = {
    immFilter: PropTypes.object.isRequired,
    onChangeSelected: PropTypes.func,
    last: PropTypes.bool
};

CardStateFilter.defaultProps = {
    onChangeSelected: () => { },
    last: false
};

module.exports = CardStateFilter;
